import { Component } from '@angular/core';
import { VonPageResponseModel } from '@von-development-studio/angular-rest-service';
import { LazyLoadEvent } from 'primeng/api';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { first } from 'rxjs/operators';
import { BaseComponent } from 'src/app/core/base/base.component';
import { PATIENT } from 'src/app/main/common/patient/patient.constants';
import { PatientService } from 'src/app/main/common/patient/patient.service';
import { CommonPatientViewModel } from 'src/app/model/common/patient.view';
import { PatientDialogComponent } from '../../patient/components/patient-dialog.component';

@Component({
  selector: 'ms-common-turn-patient-search',
  templateUrl: './turn.patient-search-dialog.component.html',
  providers: [DialogService],
})
export class TurnPatientSearchComponent extends BaseComponent {
  readonly screen = PATIENT;
  patients: VonPageResponseModel<CommonPatientViewModel> =
    {} as VonPageResponseModel<CommonPatientViewModel>;
  patientSelected: CommonPatientViewModel = {};
  dtDocumentFilter?: string;
  dtNameFilter?: string;

  constructor(
    protected ref: DynamicDialogRef,
    protected config: DynamicDialogConfig,
    protected service: PatientService,
    protected dialogService: DialogService
  ) {
    super();
  }

  openModal = () => {
    const dialogRef = this.service.openPatientDialog(
      true,
      PatientDialogComponent
    );
    const dialogComponent =
      this.dialogService.dialogComponentRefMap.get(dialogRef)?.instance;
    dialogComponent?.unbindGlobalListeners();
    dialogRef.onClose.subscribe(this.service.patientOnClose);
    dialogRef.onDestroy.pipe(first()).subscribe(() => {
      dialogComponent?.moveOnTop();
      dialogComponent?.bindGlobalListeners();
      dialogComponent?.focus();
    });
  };

  onInit = () => {
    this.loading = true;
    this.subscriptions.push(
      this.service
        .readPatientLazyLoad()
        .subscribe((patients) => (this.patients = patients))
    );
  };

  lazyReadPatients = ($event: LazyLoadEvent) => {
    this.service.setLoadingState();
    const page = $event.first! / $event.rows!;
    this.service
      .getPatients(
        page,
        $event.rows!,
        $event.filters!.fullName,
        $event.filters!.document
      )
      .subscribe();
  };

  onRowSelect = ($event: any) => this.ref.close($event.data);
}
